module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#fb",
      toString: function () {
        return this.url;
      }
    }